<template>
    <div>
        <div class="login-box">
            <div class="card" style="margin-top: 38%;">
                <div class="body">
                    <img :src="require('@/assets/logo.png')" style=" margin: 0 auto; display: block; z-index: 2; margin-top: -82px; width: 30%; padding-top: 10px; margin-bottom: 15px;">
                    <form id="sign_in" method="POST" v-on:submit.prevent="lupaPassword" ref="form">
                        <div class="logo">
                            <a href="#" style="color: #333; font-size: 28px;">Admin<b>DAPENBI</b></a>

                        </div>
                        <div class="input-group">
                            <span class="input-group-addon">
                                <i class="material-icons">email</i>
                            </span>
                            <formline ref="email" type="text" name="email" v-model="user.email" placeholder="Email" required autofocus></formline>
                        </div>
                        <div style="margin: 0 auto; display: block; text-align: center;">
                            <button v-bind:disabled="isLoading" class="btn bg-pink btn-block waves-effect" v-waves.button style="color: #fff;">
                                <span v-if="!isLoading">Reset Password</span>
                                <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                            </button>
                        </div>
                        <div class="row m-t-15 m-b--20">
                            <div style="text-align: center; padding-bottom: 5%;">
                                <a href="" @click="$router.go('/')">Login</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div style="text-align: center; color: #fff;">
            <p>copyright 2018 | Dana Pensiun Indonesia</p>
        </div>
        <div style="text-align: center; color: #fff;">
            <p>Designed by <a href="http://birutekno.com/" style="color: #fff;">Birutekno Inc</a></p>
        </div>
    </div>
</template>

<script>
  import FormLine from '../components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine},
    name: 'Login',
    data: function () {
      return {
        user: {
          username: '',
          password: '',
          rememberMe: false
        },
        isLoading: false
      }
    },
    beforeMount () {
      const log = localStorage.getItem('_token')
      const akses = localStorage.getItem('akses')

      if (log && akses) this.$router.replace('/main/dashboard')
    },
    methods: {
      lupaPassword () {
        this.isLoading = true
        api.post('/lupa-password-admin', this.user).then(result => {
          this.isLoading = false
          this.$swal('Perhatian', 'Lupa Password Berhasil.', 'success').then(() => {
            this.$router.replace('/')
            location.reload()
            this.isLoading = false
          })
        }).catch(e => {
          this.$swal('Perhatian', e.response.data.message, 'error')
          this.isLoading = false
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/LupaPassword.vue